export const light = {
	dark: false,
	colors: {
		background: '#FFFFFF',
		surface: '#F9F9F9',
		primary: '#581866',
		secondary: '#8E2569',
		error: '#f42d2d',
		info: '#4496F3',
		success: '#04AB15',
		warning: '#ffa02e',
	},
};

export const dark = {
	dark: true,
	colors: {
		background: '#4A4A4A',
		surface: '#F9F9F9',
		primary: '#581866',
		secondary: '#8E2569',
		error: '#f42d2d',
		info: '#4496F3',
		success: '#04AB15',
		warning: '#ffa02e',
	},
};
